export type JsonSchemaProperty = {
  key: string
  type: string[]
  title: string
}

export type JsonSchemaItem = {
  type: 'object'
  required: string[]
  properties: Record<string, JsonSchemaProperty>
}

export type ProvidedSchema = {
  items: JsonSchemaItem[]
}

export type RowData = Record<string, string>

export type UIColumn = JsonSchemaProperty & { uiId: string }

export const PRIMARY_TYPE_OPTIONS = ['string', 'number', 'boolean'] as const
export type PrimaryType = (typeof PRIMARY_TYPE_OPTIONS)[number]
